import { take } from 'redux-saga/effects';

import { type GeneratorResult, OperationStatus, selectTyped } from '@pressreader/appstore';
import { IssuePageSet } from '@pressreader/social-types';

import { loadPageSetFinishedActionList } from '../../actions';
import { selectPageSetById, selectPageSetStatusById } from '../../selectors';

function* waitUntilPageSetLoaded(pageSetId: string): GeneratorResult<void> {
    const initialStatus = yield* selectTyped(selectPageSetStatusById, { pageSetId });

    if (initialStatus !== OperationStatus.Pending) {
        return;
    }

    yield take([...loadPageSetFinishedActionList]);
    const status = yield* selectTyped(selectPageSetStatusById, { pageSetId });

    if (status !== OperationStatus.Pending) {
        return;
    }
    yield* waitUntilPageSetLoaded(pageSetId);
}

function* getOrWaitForPageSet(pageSetId: string): GeneratorResult<IssuePageSet | null> {
    yield* waitUntilPageSetLoaded(pageSetId);

    const status = yield* selectTyped(selectPageSetStatusById, { pageSetId });

    const isNonEmptyOrFailedStatus = status != null && status !== OperationStatus.None && status !== OperationStatus.Failed;
    if (isNonEmptyOrFailedStatus) {
        if (status === OperationStatus.Done) {
            const pageSet = yield* selectTyped(selectPageSetById, { pageSetId });
            return pageSet ?? null;
        }
        return yield* getOrWaitForPageSet(pageSetId);
    }

    return null;
}

export { getOrWaitForPageSet, waitUntilPageSetLoaded };
